import { BROADCAST_UPLOAD_OVERLAY } from 'actions/Types';
import { UPPER_LEFT, OverlayStyles } from 'constants/LayerPositions';
import { withCurrentParams, handleDocumentUpload } from 'actions/utils';

/**
 * Upload overlay is used to upload overlay files using s3 proxy apis in S3 bucket
 */
export default source => {
  return withCurrentParams((dispatch, { teamId, eventId, broadcastId }) => {
    const action = {
      type: BROADCAST_UPLOAD_OVERLAY,
      request: async apiClient => {
        const { type, title, file } = source;

        let payload = {
          name: title,
          description: 'Overlay',
          isStudioMedia: true
        };

        const eventDocId = await handleDocumentUpload(
          apiClient,
          teamId,
          eventId,
          payload,
          file
        );

        payload = {
          source: {
            type,
            title,
            value: eventDocId
          },
          layer: {
            title: UPPER_LEFT,
            style: OverlayStyles[UPPER_LEFT]
          }
        };

        const broadcast = await apiClient.broadcast.createOverlay(
          teamId,
          eventId,
          broadcastId,
          payload
        );

        const { overlays } = broadcast;
        const createdOverlay = overlays.find(
          overlay => overlay.source.value === eventDocId
        );
        return [createdOverlay];
      }
    };
    dispatch(action);
  });
};
